<template>
	<div class="download-center-page">
		<el-card class="main-card" shadow="hover">
			<!-- 顶部操作栏 -->
			<div class="header-actions">
				<h3 class="page-title">资源下载中心</h3>
				<el-input
					v-model="searchKeyword"
					placeholder="搜索文件名或描述..."
					class="search-input"
					clearable
					:prefix-icon="Search"
				/>
			</div>

			<!-- 数据表格 -->
			<el-table 
				:data="filteredTableData" 
				style="width: 100%" 
				stripe
				border
				:default-sort="{prop: 'date', order: 'descending'}"
				v-loading="loading"
			>
				<el-table-column prop="date" label="更新日期" sortable width="180" align="center">
					<template #default="scope">
						<span class="date-text">{{ scope.row.date }}</span>
					</template>
				</el-table-column>
				
				<el-table-column prop="name" label="文件名称" min-width="250">
					<template #default="scope">
						<div class="file-name-cell">
							<el-icon class="file-icon" :color="getFileIconColor(scope.row.type)">
								<component :is="getFileIcon(scope.row.type)" />
							</el-icon>
							<span :title="scope.row.name">{{ scope.row.name }}</span>
						</div>
					</template>
				</el-table-column>
				
				<el-table-column prop="type" label="类型" width="100" align="center">
					<template #default="scope">
						<el-tag size="small" effect="plain">{{ scope.row.type }}</el-tag>
					</template>
				</el-table-column>
				
				<el-table-column prop="describe" label="描述" min-width="200" show-overflow-tooltip align="center" />
				
				<el-table-column prop="issued_by" label="发布人" width="120" align="center" />
				
				<el-table-column label="操作" width="120" align="center" fixed="right">
					<template #default="scope">
						<el-button 
							link 
							type="primary" 
							@click="handleDownload(scope.row)"
						>
							<el-icon class="btn-icon"><Download /></el-icon>
							下载
						</el-button>
					</template>
				</el-table-column>
				
				<template #empty>
					<el-empty description="未找到相关文件" />
				</template>
			</el-table>
		</el-card>
	</div>
</template>

<script>
	import { Search, Download, Picture, Document, Files, Box } from '@element-plus/icons-vue';

	export default {
		components: {
			Search, Download, Picture, Document, Files, Box
		},
		data() {
			return {
				loading: false,
				searchKeyword: '',
				tableData: [
					{
						date: '2025-06-11 14:20:00',
						name: '快递公司红章证明-海南蝴蝶台风-文昌-82011',
						type: '图片',
						describe: '台风期间快递延误证明',
						issued_by: "运营部",
						download_link: 'http://8.134.179.130:6868/20250612081038.jpg'
					},
					{
						date: '2025-06-11 14:20:00',
						name: '快递公司红章证明-海南蝴蝶台风-华南06-82012',
						type: '图片',
						describe: '',
						issued_by: "运营部",
						download_link: 'http://8.134.179.130:6868/20250612081038.jpg'
					},
					{
						date: '2025-06-12 11:22:00',
						name: '全网时效报表20250612',
						type: '表格',
						describe: '每日全网时效统计数据',
						issued_by: "数据中心",
						download_link: 'http://8.134.179.130:6868/report.xlsx'
					},
					{
						date: '2025-06-12 15:22:00',
						name: '快件操作指引补充-20250601',
						type: '文档',
						describe: '最新操作规范补充说明',
						issued_by: "质控部",
						download_link: 'http://8.134.179.130:6868/guide.pdf'
					},
					{
						date: '2023-03-08',
						name: '菜鸟打印组件',
						type: '应用程序',
						describe: '菜鸟打印组件安装包',
						issued_by: "林桦",
						download_link: 'http://cloudprint.cainiao.com/cloudprint/client/CNPrintSetup.exe'
					},
					{
						date: '2023-03-20',
						name: '快宝云打印代理',
						type: '应用程序',
						describe: '快宝云打印代理服务',
						issued_by: "技术部",
						download_link: 'https://ckd.so/ydy'
					}
				]
			};
		},
		computed: {
			filteredTableData() {
				if (!this.searchKeyword) return this.tableData;
				const keyword = this.searchKeyword.toLowerCase();
				return this.tableData.filter(item => 
					item.name.toLowerCase().includes(keyword) || 
					(item.describe && item.describe.toLowerCase().includes(keyword))
				);
			}
		},
		methods: {
			getFileIcon(type) {
				if (type.includes('图片')) return Picture;
				if (type.includes('表格')) return Files;
				if (type.includes('文档')) return Document;
				if (type.includes('应用')) return Box;
				return Document; // 默认图标
			},
			getFileIconColor(type) {
				if (type.includes('图片')) return '#67C23A'; // Green
				if (type.includes('表格')) return '#409EFF'; // Blue
				if (type.includes('文档')) return '#E6A23C'; // Orange
				if (type.includes('应用')) return '#909399'; // Gray
				return '#909399';
			},
			handleDownload(row) {
				if (row.download_link) {
					window.open(row.download_link, '_blank');
				} else {
					this.$message.warning('暂无下载链接');
				}
			}
		}
	};
</script>

<style scoped lang="scss">
	.download-center-page {
		padding: 20px;
		background-color: #f5f7fa;
		min-height: 100vh;
	}

	.main-card {
		.header-actions {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 20px;
			
			.page-title {
				margin: 0;
				font-size: 18px;
				color: #303133;
				font-weight: 600;
			}
			
			.search-input {
				width: 300px;
			}
		}

		.date-text {
			color: #606266;
			font-size: 13px;
		}

		.file-name-cell {
			display: flex;
			align-items: center;
			gap: 8px;
			
			.file-icon {
				font-size: 18px;
			}
			
			span {
				font-weight: 500;
				color: #303133;
			}
		}
		
		.btn-icon {
			margin-right: 4px;
		}
	}
</style>